<template>
  <div class="bzscbb-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="车间">
              <el-select v-model="searchForm.factory" style="width: 120px" @keyup.enter.native="getData" filterable clearable>
                <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :key="item.factory_id" :label="item.simple_name"  :value="item.factory_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="入库日期">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="date">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="完整">
              <el-select v-model="searchForm.isall" style="width:100px" clearable placeholder="请选择">
                <el-option label="不完整" value="0"></el-option>
                <el-option label="完整" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="searchForm.search" placeholder="请输入生产单号、经销商"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="getData" icon="el-icon-search">搜索</el-button>
              <el-button icon="el-icon-printer" @click="print">打印报表</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" v-loading="loading">
            <table class="tcf-bb-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>生产单号</th>
                  <th>经销商</th>
                  <th>单位</th>
                  <th>入库数量</th>
                  <th>入库包号</th>
                  <th>完整</th>
                  <th>金额</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(t,index) in tableData">
                  <td>
                    <span v-if="t.produnum!==null&&t.produnum!==''&&t.produnum!==undefined">{{index+1}}</span>
                  </td>
                  <td>{{t.produnum}}</td>
                  <td>{{t.delname}}</td>
                  <td>{{t.unit}}</td>
                  <td>{{t.incount}}</td>
                  <td>{{t.packnums}}</td>
                  <td>{{t.mark}}</td>
                  <td>{{t.amount}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getErpInReport, getFactoryList, getGroupInfoByUser } from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'bzwcbb',
  computed: {
    user: getUser
  },
  data() {
    return {
      fullscreenLoading: false,
      loading: false,
      searchForm: {
        time: '',
        isall: '',
        search: '',
        factory: ''
      },
      data: '',
      completionAmount: '',
      workAmount: '',
      woedAmount: '',
      tableData: [],
      factoryList: [],
      group: {
        dBrand: 1
      }
    }
  },
  created() {
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    getFactoryList().then(response => {
      this.factoryList = response.data
    })
    const myDate = new Date()
    const year = myDate.getFullYear()
    let month = myDate.getMonth() + 1
    let day = myDate.getDate()
    month = month > 9 ? month + '' : '0' + month
    day = day > 9 ? day + '' : '0' + day
    this.searchForm.time = year + '-' + month + '-' + day
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        time: this.searchForm.time,
        isall: this.searchForm.isall,
        search: this.searchForm.search,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        factory: this.searchForm.factory
      }
      getErpInReport(data).then(response => {
        const lst = response.data
        this.tableData = lst
        let html = ''
        let time = ''
        if (this.searchForm.time !== null && this.searchForm.time.trim() !== '' ) {
          const darr = this.searchForm.time.split('-')
          time = darr[0] + '年' + darr[1] + '月' + darr[2] + '日'
        }
        let totalAmount = 0.0
        let xuhao = ''
        for (let i = 0; i < lst.length; i++) {
          xuhao = lst[i].xuhao
          if (xuhao === 0) {
            xuhao = ''
          }
          html += '<tr style="text-align:center;border-collapse:collapse;border:1px solid black;height:8mm;font-size:16pt;word-wrap:break-word;word-break:break-all;">'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+xuhao+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].produnum+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].delname+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].unit+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].incount+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].packnums+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].mark+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].amount+'</td>'+
            '</tr>'
          totalAmount = lst[i].amount
        }
        html += '</tbody>\n' +
          '<tfoot>\n' +
          '<tr>\n' +
          '<td colspan="8"  style="text-align: right;font-size:12pt;padding-top: 3mm;">\n' +
          '第&nbsp;<span tdata="pageNO" format="#">#</span>&nbsp;/&nbsp;<span tdata="pageCount" format="#">#</span>&nbsp;页\n' +
          '</td>\n' +
          '</tr>\n' +
          '</tfoot>\n' +
          '</table>'
        html = '<table style="border-collapse: collapse;page-break-before:always;font-family:宋体;width: 100%;">\n' +
          '<thead>\n' +
          '<tr>\n' +
          '<td colspan="8" style="font-size:30pt;text-align:center;line-height:60px;font-weight: bold;" id="title" >\n' +
          '<span>入库单</span>\n' +
          '</td>\n' +
          '</tr>\n' +
          '<tr>\n' +
          '<td colspan="8" style="font-size:14pt;line-height:30px;text-align:center;" >'+time+'</td>\n' +
          '</tr>\n' +
          '<tr style="text-align:center;border-collapse: collapse;border:1px solid black;height:8mm;font-size:16pt;word-break: keep-all;white-space:nowrap;">\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;"></td>\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;"></td>\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;"></td>\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;"></td>\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;"></td>\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;"></td>\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;"></td>\n' +
          '<td id="totalAmount" style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;">总金额:'+totalAmount+'</td>\n' +
          '</tr>\n' +
          '<tr style="text-align:center;border-collapse: collapse;border:1px solid black;height:8mm;font-size:16pt;word-break: keep-all;white-space:nowrap;">\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;">序号</td>\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;">生产单号</td>\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;">经销商</td>\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;">单位</td>\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;">入库数量</td>\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;">入库包号</td>\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;">完整</td>\n' +
          '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;">金额</td>\n' +
          '</tr>\n' +
          '</thead>\n' +
          '<tbody>' + html
        this.data = html
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    print() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        LODOP.PRINT_INIT('入库报表打印')
        LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
        LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
        LODOP.ADD_PRINT_TABLE(30, '11mm', '100%', '100%', this.data)
        LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
        LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
        LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
        LODOP.NewPageA()
        LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
        LODOP.PREVIEW()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .tcf-bb-table{
    width: 100%;
    background-color: #fff;
    border-collapse: collapse;
    border-spacing: 0;
    font-size: 13px;
    text-align: center;
    margin-top: 20px;
    thead{
      color: #909399;
      font-weight: 500;
      tr{
        th{
          border: 1px solid #EBEEF5;
          background: #f6f8fa;
          color: #303133;
          padding: 12px 0;
        }
      }
    }
    tbody{
      tr{
        td{
          border: 1px solid #EBEEF5;
          color: #303133;
          padding: 12px 0;
        }
        &:hover{
          background: #f3f6f9;
        }
      }
    }
  }
</style>
